import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { BaseURL, uniqueToken } from '../../api/DataApis';

const AddBankAccount = () => {
  const navigate = useNavigate();
  const { user_id } = useParams(); // get user_id from route params

  const [formData, setFormData] = useState({
    bank_name: "",
    account_number: "",
    ifsc_code: "",
    account_holder_name: ""
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: 'Adding Bank Account...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await axios.post(
        `${BaseURL}/bank-account/${user_id}`,
        formData,
        {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        }
      );

      Swal.close();

      if (response.data?.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Bank account added successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/bank-accounts/bank-account-listing/${user_id}`); // ✅ redirect on success
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data?.message || "Something went wrong!",
        });
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: error.response?.data?.message || "Something went wrong!",
      });
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="portlet light bordered">
              <div className="portlet-title row">
                <div className="caption font-dark col-md-10">
                  <h4 className="caption-subject bold uppercase mx-3">
                    Add Bank Account
                  </h4>
                </div>
                <div className="caption font-dark col-md-2">
                  <button className="btn btn-success" onClick={() => navigate(-1)}>
                    Back
                  </button>
                </div>
              </div>

              <div className="portlet-body mx-3">
                <hr />
                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <div className="row">
                      <label className="col-sm-2 control-label">Bank Name</label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="bank_name"
                          value={formData.bank_name}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <label className="col-sm-2 control-label">Account Number</label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="account_number"
                          value={formData.account_number}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <label className="col-sm-2 control-label">IFSC Code</label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="ifsc_code"
                          value={formData.ifsc_code}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <label className="col-sm-2 control-label">Account Holder Name</label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="account_holder_name"
                          value={formData.account_holder_name}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-sm-offset-2 col-sm-8">
                      <button type="submit" className="btn btn-success">
                        Add Bank Account
                      </button>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBankAccount;
